import {ChipsOption} from 'platform/components';

import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

const yesNoOptions: ChipsOption[] = [
  {label: i18n.t('general.labels.yes'), value: 'yes'},
  {label: i18n.t('general.labels.no'), value: 'no'},
];

export function ServicedInAuthorizedNetworkChips() {
  return (
    <Field
      type="chips"
      name="servicedInAuthorizedNetwork"
      label={i18n.t('entity.vehicle.labels.servicedInAuthorizedNetwork')}
      tooltip={i18n.t('entity.vehicle.labels.servicedInAuthorizedNetworkTooltip')}
      options={yesNoOptions}
      isDeselectable
    />
  );
}
